"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printfFunction = void 0;
const constants_1 = require("../../constants");
const errors_1 = require("../../errors/errors");
const REGEX = /%[c,f,d]+/g;
const printfFunction = (stringInput, ...args) => {
    const found = stringInput.match(REGEX);
    if (found == null) {
        return stringInput;
    }
    if (found.length != args.length) {
        throw new errors_1.PrintfError();
    }
    let index = 0;
    const replaceTokens = (match, ..._others) => {
        const currentArg = args[index];
        index++;
        if (match == '%c') {
            if (typeof currentArg == 'string') {
                if (currentArg.length == 1) {
                    return currentArg;
                }
                else {
                    throw new errors_1.PrintfError();
                }
            }
            return String.fromCharCode(currentArg);
        }
        else if (match == '%d') {
            if (typeof currentArg == 'string') {
                return currentArg.charCodeAt(0);
            }
            return Math.floor(currentArg);
        }
        else {
            if (typeof currentArg == 'string' && Number.isInteger(currentArg)) {
                throw new errors_1.PrintfError();
            }
            return currentArg.toFixed(constants_1.FLOAT_PRECISION);
        }
    };
    const replacedString = stringInput.replace(REGEX, replaceTokens);
    return replacedString;
};
exports.printfFunction = printfFunction;
//# sourceMappingURL=printf.js.map